module.exports = __webpack_public_path__ + "img/menu-abonent.64085944.svg";